import axios from 'axios';

export default function uploadFile(formData: FormData) {
  return axios.post('api/shortagesdisputedocument/UploadSupportingDocument', formData);
}
